import React from "react"
import { FrequentQuestionsModel } from "../../Model/rentalsModel"

export default function FAQModal({ index, faqs }: FrequentQuestionsModel) {
  const containerRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const container = containerRef.current

    if (!container) return
    const selectedChild = containerRef.current.children[index]

    if (!selectedChild) return
    selectedChild.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "start",
    })
  }, [containerRef])

  return (
    <div data-cy="dashboard-rental-faq-modal">
      <h3 className="pb-4">FAQ</h3>
      <div ref={containerRef} className="overflow-y-auto">
        {faqs.map(faq => (
          <li key={faq.question} className="py-4 list-none">
            <h4 className="py-2">{faq.question}</h4>
            <div>{faq.answer}</div>
          </li>
        ))}
      </div>
    </div>
  )
}
